import { HipoApiErrorType } from "../../../util/error/errorConstants";

type FetcherErrorType = "ConnectionError" | "ApiError" | HipoApiErrorType;

class FetcherError extends Error {
  data: any;
  statusCode: number;
  errorType: FetcherErrorType;

  constructor(
    options: {
      statusCode: number;
      errorType: FetcherErrorType;
      data: any;
      message: string;
    },
    ...args: any[]
  ) {
    super(...args);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetcherError);
    }

    this.name = "FetcherError";
    this.statusCode = options.statusCode;
    this.errorType = options.errorType;
    this.data = options.data;
    this.message = options.message;
  }
}

export default FetcherError;
